export default __webpack_public_path__ + "static/media/edu-3.e8a51991.jpg";